
import * as unsplashRuntime$VPI93epGoivcVOh_45PbehOi2_uC4SwPC9_45JeyeGQRrZ0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/unsplash'
import * as cantoRuntime$_0BAu3bwa2_3zjq1vNUuhX5lTS4mtsJ7MemGqPm4_45zto from '/app/node_modules/@nuxt/image/dist/runtime/providers/imgix'
import * as awsRuntime$_0BAu3bwa2_3zjq1vNUuhX5lTS4mtsJ7MemGqPm4_45zto from '/app/node_modules/@nuxt/image/dist/runtime/providers/imgix'
import * as localRuntime$_0BAu3bwa2_3zjq1vNUuhX5lTS4mtsJ7MemGqPm4_45zto from '/app/node_modules/@nuxt/image/dist/runtime/providers/imgix'
import * as ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0 from '/app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['unsplash']: { provider: unsplashRuntime$VPI93epGoivcVOh_45PbehOi2_uC4SwPC9_45JeyeGQRrZ0, defaults: undefined },
  ['canto']: { provider: cantoRuntime$_0BAu3bwa2_3zjq1vNUuhX5lTS4mtsJ7MemGqPm4_45zto, defaults: {"baseURL":"https://atlantisbahamas.imgix.net"} },
  ['aws']: { provider: awsRuntime$_0BAu3bwa2_3zjq1vNUuhX5lTS4mtsJ7MemGqPm4_45zto, defaults: {"baseURL":"https://atlantisbahamas.imgix.net"} },
  ['local']: { provider: localRuntime$_0BAu3bwa2_3zjq1vNUuhX5lTS4mtsJ7MemGqPm4_45zto, defaults: {"baseURL":"https://atlantisbahamas.imgix.net"} },
  ['ipx']: { provider: ipxRuntime$c5bYuDBMFn7pLf3NiYFFTgAhjpBXVLzp5UXALzaMXO0, defaults: {} }
}
        